import { inject, injectable } from 'inversify'
import { action, makeObservable, observable } from 'mobx'
import { Types } from '@core/ioc/types'
import type { AppLifecycle } from '@core/interfaces/app-lifecycle'
import type { ConnectivityGateway } from '@core/services/connectivity.gateway'

/** Source of truth for whether the app currently believes it is online. */
@injectable()
export class ConnectivityRepository implements AppLifecycle {
  // A preference-like value that always resolves — optimistic until the gateway
  // says otherwise, so nothing renders an offline banner during bootstrap.
  isOnlinePm = true

  @inject(Types.IConnectivityGateway)
  private connectivityGateway!: ConnectivityGateway

  private watchesConnectivity = false

  constructor() {
    makeObservable(this, {
      isOnlinePm: observable,
      setOnline: action,
    })
  }

  // Called once from AppPresenter.load() — property-injected deps aren't
  // populated during construction, same pattern as the other init()s.
  initialize = action(() => {
    this.isOnlinePm = this.connectivityGateway.isOnline()
    if (this.watchesConnectivity) return

    this.connectivityGateway.onChange((online) => this.setOnline(online))
    this.watchesConnectivity = true
  })

  setOnline(online: boolean) {
    this.isOnlinePm = online
  }
}
